<footer>
    <div class="copyright">copyright © 2026 Poll Guru</div>
</footer>

<style>
    footer {    
        background-color: #fdfdfd;
        padding: 10px 10px;
        box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
        text-align: center;
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
    }

</style>